import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/HomePage";
import Layout from "./components/Layout/Layout";
import MyEsimPage from "./pages/MyEsimPage";
import PurchasePage from "./pages/PurchasePage";
import CheckoutPage from "./pages/CheckoutPage";
import PolicyPage from "./pages/PolicyPage";

import CartProviderLayout from "./components/Layout/CartProviderLayout";
import AuthCallback from "./components/routing/AuthCallback";
import useAuthSync from "./components/auth/useAuthSync";

// ✅ Import your PaymentSuccessPage
import OrderDetailPage from "./pages/OrderDetailPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { Package } from "lucide-react";
import PackageDetailPage from "./pages/PackageDetailPage";
import CompanyProfilePage from "./pages/CompanyProfilePage";
import FaQPage from "./pages/FaQPage";
import HowToBuyPage from "./pages/HowToBuyPage";

function App() {
  useAuthSync();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route element={<CartProviderLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="package-detail" element={<PackageDetailPage />} />

            <Route path="/checkout" element={<CheckoutPage />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route path="my-esims" element={<MyEsimPage />} />
            <Route path="/purchase" element={<PurchasePage />} />
            <Route path="order/:id/:channelid" element={<OrderDetailPage />} />
          </Route>
          <Route path="/company-profile" element={<CompanyProfilePage />} />
          <Route path="/faq" element={<FaQPage />} />
          <Route path="/how-to-buy" element={<HowToBuyPage />} />
          <Route path="/privacy-policy" element={<PolicyPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="*" element={<div>404 Not Found</div>} />
        </Route>{" "}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
